import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {ProductContent} from '../model/Entities/ProductContent';
import {ProductFile} from '../model/Entities/ProductFile';

@Injectable()
export class ProductFileService extends ApiService<ProductFile> {

    protected apiUrl = 'api/product-files';  // URL to web api

    getImagesBaseUrl(): string {
        return this.apiRoot + '/files/product-files';
    }

    protected getObjectType(): any {
        return ProductFile;
    }

}



// WEBPACK FOOTER //
// /app/src/services/product-file.service.ts